import restClient from './restClient';
import { environment } from '../environments/environment';
import moment from 'moment';

const API_V1 = `${environment.REACT_APP_BASE_URL}/api/v1/`;
const shiftService = {

  getShifts: (params: { doctorID: string; clinicID: string; startDate?: any, endDate?: any }) => {
    const currentDate = moment().format('DD/MM/YYYY');
    return restClient.makeGetRequest(`${API_V1}shift`, {
      startDate: currentDate, endDate: currentDate,
      ...params,
    });
  },

  addShift: (payload: any) => {
    return restClient.makePostRequest(`${API_V1}shift`, payload);
  },

  editShift: (payload: any) => {
    if (payload.shiftID) {
      // return restClient.makePutRequest(`${API_V1}shift/payload.shiftID`, payload);
      return shiftService.updateShift(payload);
    } else {
      return restClient.makePostRequest(`${API_V1}shift`, payload);
    }
  },

  updateShift: (payload: any) => {
    return restClient.makePutRequest(`${API_V1}shift/${payload.shiftID}`, payload);
  },

  deleteShift: (shiftID: string) => {
    return restClient.makeDeleteRequest(`${API_V1}shift/${shiftID}`);
  },

  getClinicSchedule: (doctorID: string) => {
    return restClient.makeGetRequest(`${API_V1}shift/clinic-schedule`, { doctorID });
  },

  inspectShift: (payload: { shiftID: string }) => {
    return restClient.makePostRequest(`${API_V1}shift/${payload.shiftID}/inspect`, payload);
  },

  getNextAvailableSlot: (params: { doctorID: string; clinicID: string; date?: any, allowTeleConsultShifts?: boolean }) => {
    const currentDate = moment().format('YYYY-MM-DD');
    return restClient.makeGetRequest(`${API_V1}appointment/next-available-slot`, {
      date: currentDate, allowTeleConsultShifts: true,
      ...params,
    });
  },

  getOnlineSchedule: (params: { doctorID: string; clinicID: string; date: any, allowTeleConsultShifts?: boolean }) => {
    return restClient.makeGetRequest(`${API_V1}appointment/online-schedule`, {
      allowTeleConsultShifts: true,
      ...params,
    });
  },
};

export default shiftService;